import React from 'react';

const Right = () => (
  <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.08751 0.425293L0.912506 1.60029L4.72917 5.42529L0.912506 9.25029L2.08751 10.4253L7.08751 5.42529L2.08751 0.425293Z" fill="black" fillOpacity="0.87"/>
  </svg>
);

export default Right;